import { SET_MAIN_DOCUMENT } from '../actions/main';
import { Page } from '../types/page/page';

export default (
  state: MainState = {},
  action: Record<string, any>
): MainState => {
  if (action.type === SET_MAIN_DOCUMENT) {
    return action.payload;
  }
  return state;
};

export type MainState = {
  document?: Page;
  error?: any;
  loading?: boolean;
};
